import { keyframes, style } from '@vanilla-extract/css';

const pathLeftAnimation = keyframes({
  '0%': {
    transform: 'translateY(-5%)',
  },
  '50%': {
    transform: 'translateY(5%)',
  },
  '100%': {
    transform: 'translateY(-5%)',
  },
});

const pathRightAnimation = keyframes({
  '0%': {
    transform: 'translateY(5%)',
  },
  '50%': {
    transform: 'translateY(-5%)',
  },
  '100%': {
    transform: 'translateY(5%)',
  },
});

const pathLeft = style({
  animation: `${pathLeftAnimation} 1.5s ease-in-out infinite`,
});

const pathRight = style({
  animation: `${pathRightAnimation} 1.5s ease-in-out infinite`,
});

const rotateAnimation = keyframes({
  '0%': {
    transform: 'rotate(0deg)',
  },
  '20%': {
    transform: 'rotate(360deg)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
});

const pathGroup = style({
  transformOrigin: 'center',
  animation: `${rotateAnimation} 3s ease-in-out infinite`,
});

export const css = { pathGroup, pathLeft, pathRight };
